module.exports = __webpack_public_path__ + "img/interesse_4_selecionado.7f41d099.svg";